import Alpine from 'alpinejs';
import ajax from '@imacrayon/alpine-ajax';
import collapse from '@alpinejs/collapse';
window.Alpine = Alpine;
Alpine.plugin(ajax);
Alpine.plugin(collapse);
Alpine.start();

// Navigation
import Navigation from './modules/_dropdown_sticky_navigation.js';

// Animations
import Animations from './modules/_animations.js';

// Forms (currently just password reveal)
import Forms from './modules/_forms.js';

function init() {
  Navigation.setup();
  Animations.setup();
  Forms.setup();
}

init();